const CROUTON_PREFIX = "ipl-swiggy-sixes-timer-crouton";
export const SWIGGY_SIXES_CROUTON_DATA_TEST_IDS = {
    CONTAINER_SIX_HIT: `${CROUTON_PREFIX}-container__SIX_HIT`,
    CONTAINER_CONSECUTIVE_SIXES_HIT: `${CROUTON_PREFIX}-container__CONSECUTIVE_SIXES_HIT`,
    CONTAINER_EXPIRED: `${CROUTON_PREFIX}-container__EXPIRED`,
    TEXT: `${CROUTON_PREFIX}-ticker-text`,
};

const STRIP_PREFIX = "savings-line-item-footer-comms";
export const SAVINGS_ITEM_FOOTER_COMMS_DATA_TEST_IDS = {
    CONTAINER: `${STRIP_PREFIX}-container`,
    TEXT: `${STRIP_PREFIX}-text`,
    ICON: `${STRIP_PREFIX}-icon`,
    TIP_ARROW: `${STRIP_PREFIX}-tip-arrow`,
    CLOSE_ICON: `${STRIP_PREFIX}-close-icon`,
};

const COUPON_TIMER_TAG_PREFIX = "ipl-swiggy-sixes-coupon-timer-tag";
export const IPL_TIMER_TAG_DATA_TEST_IDS = {
    CONTAINER: `${COUPON_TIMER_TAG_PREFIX}-container`,
    TEXT: `${COUPON_TIMER_TAG_PREFIX}-text`,
};
